/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material';
import { SettingsIcon } from '@/components/icons/SettingsIcon';
import { NoContextTabView } from '@/components/layouts/TabView';
import { getSettingsTabs } from '@/app/tabs';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { DarkModeSwitch } from '@/components/buttons/DarkModeSwitch';

export const SettingsView = () => {
	const theme = useTheme();
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const {
		data: userDetails,
		isLoading,
		isUninitialized,
	} = useGetUserDetailsQuery({ email }, { skip: !email });

	const { getFeatureFlags } = useFeatureFlagContext();

	const viewConfigTable = Boolean(getFeatureFlags('viewConfigTable')?.active);

	const canViewStageTable = Boolean(userDetails?.principleUser);

	const canViewGroup = Boolean(userDetails?.canViewGroup);

	const settingsTabs = getSettingsTabs();
	const userProfile = useMemo(
		() => settingsTabs.find((t) => (canViewGroup ? t.value === 'users' : t.value === 'user')),
		[canViewGroup, settingsTabs],
	);
	const brokerageProfile = useMemo(
		() =>
			settingsTabs.find((t) =>
				canViewGroup ? t.value === 'brokerGroups' : t.value === 'brokerage',
			),
		[canViewGroup, settingsTabs],
	);

	const tabs = useMemo(() => {
		if (isLoading || isUninitialized) return [];

		return [
			userProfile,
			brokerageProfile,
			...settingsTabs.filter((t) => {
				if (t.value === 'config') return viewConfigTable;
				if (t.value === 'pipelines') return canViewStageTable;
				if (t.value === 'user' || t.value === 'users') return false;
				if (t.value === 'brokerage' || t.value === 'brokerGroups') return false;
				return true;
			}),
		];
	}, [
		isLoading,
		isUninitialized,
		viewConfigTable,
		canViewStageTable,
		canViewGroup,
		settingsTabs,
		userProfile,
		brokerageProfile,
	]);

	return (
		<NoContextTabView
			tabs={tabs}
			title='Settings'
			icon={
				<SettingsIcon {...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })} />
			}
			actions={<DarkModeSwitch />}
		/>
	);
};
